var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFillContractSlotIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#008C15",
    d: "M 18 36 C 27.941406 36 36 27.941406 36 18 C 36 8.058594 27.941406 0 18 0 C 8.058594 0 0 8.058594 0 18 C 0 27.941406 8.058594 36 18 36 Z M 16.3125 24.1875 L 16.3125 19.6875 L 11.8125 19.6875 C 10.878906 19.6875 10.125 18.933594 10.125 18 C 10.125 17.066406 10.878906 16.3125 11.8125 16.3125 L 16.3125 16.3125 L 16.3125 11.8125 C 16.3125 10.878906 17.066406 10.125 18 10.125 C 18.933594 10.125 19.6875 10.878906 19.6875 11.8125 L 19.6875 16.3125 L 24.1875 16.3125 C 25.121094 16.3125 25.875 17.066406 25.875 18 C 25.875 18.933594 25.121094 19.6875 24.1875 19.6875 L 19.6875 19.6875 L 19.6875 24.1875 C 19.6875 25.121094 18.933594 25.875 18 25.875 C 17.066406 25.875 16.3125 25.121094 16.3125 24.1875 Z M 16.3125 24.1875 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillContractSlotIcon);
export default __webpack_public_path__ + "static/media/FillContractSlotIcon.dd7356e882f4ffb2dd8a9e9d712c2606.svg";
export { ForwardRef as ReactComponent };